import { IconButton, Skeleton, Stack, Typography } from "@mui/material";
import DeleteIcon from "src/components/shared/icon/DeleteIcon";
import DownloadIcon from "src/components/shared/icon/DownloadIcon";
import appConfig from "src/config/env";
import useDebtReportDelete from "../hooks/useDebtReportDelete";
import { enqueueSnackbar } from "notistack";

const DebtReportFileItem = ({ item: { fileName, url, _id } }) => {
  const { trigger } = useDebtReportDelete(_id);
  const handleDownload = () => {
    window.open(appConfig.API_FILE + "/" + url, "_blank");
  };

  const handleDelete = async () => {
    try {
      const res = await trigger();
      if (res.success) {
        enqueueSnackbar("Xoá báo cáo thành công", { variant: "success" });
      } else {
        enqueueSnackbar("Lỗi khi xoá báo cáo", { variant: "error" });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar("Lỗi khi xoá báo cáo", { variant: "error" });
    }
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      justifyContent="space-between"
    >
      {fileName ? (
        <Typography>{fileName}</Typography>
      ) : (
        <Skeleton
          variant="text"
          width="70%"
          height="40px"
        />
      )}
      <Stack direction="row">
        <IconButton onClick={handleDownload}>
          <DownloadIcon />
        </IconButton>
        <IconButton onClick={handleDelete}>
          <DeleteIcon color="red" />
        </IconButton>
      </Stack>
    </Stack>
  );
};

export default DebtReportFileItem;
